<template>
  <v-row class="rounded no-gutters back-filtro pa-1" justify="center" align="center">
    <v-col cols="12" class="ma-0 pa-0 d-flex align-center">
      <span class="subtitle-1 font-weight-bold" color="primary">{{title}}</span>
      <v-tooltip top>
        <template v-slot:activator="{ on }">            
          <v-btn text icon color="primary" class="ml-auto" x-small @click="remove" v-on="on">
            <v-icon dark small>fa-trash-alt</v-icon>
          </v-btn>
        </template>
        <span>Eliminar filtro</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" class="py-0 ma-0" dense>
      <span class="text-primary">Seleccione una Opción</span>
      <v-autocomplete
        v-model="valorConsulta"
        :items="itemsData"
        item-text="texto"
        item-value="id"
        :loading="loadSelect"
        hide-details
        clearable
        outlined
        dense>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
  import axiosServices from "@/services/axiosServices.js"
  import mixinGridComponenteFiltros from "@/mixins/GridComponenteFiltros.js"

  export default {
    name:"Selector",
    mixins: [mixinGridComponenteFiltros],
    data() {
      return {
        itemsSelect: [
          {titulo:'Igual',valor: '='},

        ],
        selectOpcion    : '=',
        valorConsulta   : '',
        valorConsulta2  : '',
        itemsData       : [],
        loadSelect      : false,
      }
    },
    async mounted () {
      await this.getItems()
    },
    methods: {
      async getItems(){
        let sAux = this.inner.split(',')
        this.loadSelect = true
        let sParams = ``
        if(this.bSubdominioTemporal){
          sParams = sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
        }
        const aItems = await axiosServices.getConfiguration('/select/' + sAux[0] + '/' + this.campo , true ,sParams)
        this.itemsData = aItems.aData
        this.loadSelect = false
         
        if(!this.getbCargarStorage) this.valorConsulta = ''
      },

      stringConsulta (){
        let sConsulta = ''
        switch (this.selectOpcion) {
          case '':
            sConsulta = ''
          break
          case '>=':
            sConsulta = ">= '" + this.valorConsulta + "'"
          break
          case '<=':
            sConsulta = "<= '" + this.valorConsulta + "'"
          break
          case '=':
            sConsulta = "= '" + this.valorConsulta + "'"
          break
          case 'between':
            sConsulta = " between '" + this.valorConsulta + "' AND '" + this.valorConsulta2 +"'"
          break
        }
        this.$emit("input",sConsulta)

        this.onAddInfoFiltro(this.campo , this.title, this.cmpValorTextoSelect)
      }
    },
    computed: {
      cmpValorTextoSelect() {
        return this.itemsData.find( elemento => elemento.id == this.valorConsulta) != undefined ? this.itemsData.find( elemento => elemento.id == this.valorConsulta).texto : ''
      }
    },
    watch: {
      valorConsulta() {
        this.stringConsulta();
      },
      valorConsulta2() {
        this.stringConsulta();
      },
      selectOpcion() {
        this.stringConsulta();
      },
      indice () {
        this.getItems()
      },
      itemsData(){
        if(this.itemsData.length > 0){
          this.onAddInfoFiltro(this.campo , this.title, this.cmpValorTextoSelect)
        }
      }
    },    
  }
</script>

<style scoped>
 
</style>